/** apply font-weight to all elements that have a class whose name starts with "mantine" */
[class^="mantine"] {
	font-weight: var(--appbuilder-default-font-weight);
}
